<template>
<v-container>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-flex xs12 md44 class="my-3">

      <div class="text-xs-center">
        <h2 class="headline">運営団体について</h2>
      </div>


<div class="mb-5">

<p class="ah-regal-head" style="margin-bottom: 20px;font-size: 16px;">
アマチュア向けバスケットボール大会を運営
</p>
<p>

いつものチームの気心知れた仲間と、普段は敵同士のアイツやあの子と新しいチームでエンジョイバスケ！<br>
<br>
一般大会以外にも、同窓会、OB会、会社対抗などこんなバスケがやってみたい！というものはお気軽にお声がけください。<br>
その他、大会に出たことがないチームへのコーチ派遣や各種スクールも計画中！<br><br>
ACTIVE HOOP はバスケが大好きな人の味方です！
</p>

<p class="ah-regal-head">
運営団体
</p>
<p>
   ActiveForce
</p>
<p class="ah-regal-head">
所在地
</p>
<p>
東京都豊島区南池袋２−８−１７　第一豊南ビル６階（株）ワイズパートナーズ内
</p>
<p class="ah-regal-head">
連絡先
</p>
<p>
03-5396-7425<br>
info@ac4th.com
</p>

<p class="ah-regal-head">
代表
</p>
<p>
高橋 旭
</p>







</div>

    </v-flex>

    </v-flex>
  </v-layout>
</v-container>
</template>


<script>
export default {
  data () {
    return {
    }
  }
}

</script>

<style>
.ah-regal-head {
    margin-bottom: 0px;
    font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/components/Managementgroup.vue